import React from "react";
import { Container, Row, } from "react-bootstrap";


function Footer() {
  return (
    <Container fluid className="footer">
      <Row>
      </Row>
    </Container>
  );
}

export default Footer;
